/**
 * 算法规则池入口
 */
import RuleEngine from '../../../helpers/rules-engine'

// 以下是规则文件
import Mathcher from './rule-mathch'
import Attached from './rule-attached'
import Filter from './rule-filter'
import Prepare from './rule-prepare'
import Decision from './rule-decision'
import Ending from './rule-ending'
import After from './rule-after'


// 合并所有规则
let rules = _.concat(
                    Mathcher(),
                    Filter(),
                    Prepare(),
                    Attached(),
                    Decision(),
                    After(),
                    Ending()
                )

let R = new RuleEngine();
R.register(rules);


/**
 * 执行规则入口
 * @param  {[object]} currentMethod [当前选中的玩法]
 * @param  {[object]} bet           [当前投注对象]
 * @param  {[function]} callback    [回调]
 * @return {[object]}               [返回包含注数和金额的对象]
 */
export function execute(currentCategory, currentMethod, bet, callback, lotteryType){
    let cateName;
    _.each(currentCategory.categories, cate => {
        if(_.find(cate.methods, {menuid: currentMethod.menuid})){
            cateName = cate.title;
        }
    })
    // 等待处理的对象
    let pending = {
        currentCategory: currentCategory,
        currentMethod: {...currentMethod, modes},
        lotteryType: lotteryType,
        bet: bet,
        attached: {},
        message: [],
        mathcherName: currentCategory.name + '-' + cateName + '-' + (currentMethod.originalName || currentMethod.name)
    }

    if (window.MODEL=='DEBUG') {
        console.groupCollapsed('# DEBUG 投注算法规则日志 #');
        console.group('#待处理#');
        console.log('# 当前选中彩种：' + pending.lotteryType);
        console.log('# 当前选中玩法 #');
        console.log(pending.currentMethod);
        console.log('# 投注对象 #');
        console.log(pending.bet);
        console.groupEnd();
    }

	R.execute(pending, function(data) {
        if (window.MODEL=='DEBUG') {
            console.group('#处理完成#');
            console.log('# 显示对象 #');
            console.log(data.done.display);
            console.log('# 投注对象 #');
            console.log(data.done.submit);
            console.log('# 信息对象 #');
            console.log(data.done.message);
            console.groupEnd();
            console.groupEnd();
        }
        callback(data.done)
	});
}

const modes = [
    {modeid: 1, name: "元", rate: 1},
    {modeid: 2, name: "角", rate: 0.1},
    {modeid: 3, name: "分", rate: 0.01},
    {modeid: 4, name: "厘", rate: 0.001}
]